/* --------------------------------------------------------------------------
	News Search
-------------------------------------------------------------------------- */
"use strict";
var $ = jQuery;

function initNewsSearch() {

    var $container = $(".news-gcse-search");
    var $buttons = $container.find("button");

    $buttons.on("click", function () {
        if ($(this).hasClass("fs-swap-active")) {
            if ($(this).index() === 0) {
                $(".newsListContainer").css("display", "block");
                $(".filter_results").css("display", "block");
            } else {
                $(".newsListContainer").css("display", "none");
                $(".filter_results").css("display", "none");
            }
        }
    });
}

$(initNewsSearch);

$(document).ready(function () {
    var $searchBtn = $('button.fs-swap-active[aria-label="search"]');
    if ($searchBtn.length) {
        $(".newsListContainer").css("display", "none");
    }
});